export const SUBMIT_MEMBER_PREVIEW_SUCCESS = "SUBMIT_MEMBER_PREVIEW_SUCCESS"
export const UPDATE_MEMBER_PREVIEW_LOADING = "UPDATE_MEMBER_PREVIEW_LOADING"
export const RESET_MEMBER_VIEW_DATA = "RESET_MEMBER_VIEW_DATA"
export const UPDATE_MEMBER_INPUT_REQUIRE_ERROR = "UPDATE_MEMBER_INPUT_REQUIRE_ERROR"
export const UPDATE_ANSWER_DATA = "UPDATE_ANSWER_DATA"
export const SWITCH_MEMBER_TOGGLE_EDIT = "SWITCH_MEMBER_TOGGLE_EDIT"
export const UPDATE_SHARE_STATUS = "UPDATE_SHARE_STATUS"